export const FETCH_SCHEDULERS = 'FETCH_SCHEDULERS';
export const ADD_SCHEDULES = 'ADD_SCHEDULES';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';